import { baseRoute } from "config/const";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  let navigate = useNavigate();

  useEffect(() => {
    if (!window.location.href.includes("liff.state"))
      navigate(`${baseRoute}/home`, { replace: true });
  }, [navigate]);

  return <div />;
}
